import { Divider, Table, TableProps, Typography } from 'antd';
import { customerLookupDetailedMessages } from '../../messages/customer-lookup-detailed.message';
import React, { useEffect, useState } from 'react';
import {
  GetCustomerThirdParty,
  GetCustomerThirdPartyHistory
} from '../../hooks/customer-lookup/useCustomerReferenceInformation';
import { ThirdPartyPaymentHistoryDetail, ThirdPartyPaymentInforDetail } from '../../types/dto/customer-lookup';
import dayjs from 'dayjs';
import { useCustomerDetailByCustomerCode } from '../../hooks/customer-lookup/useCustomerDetail';

type CollectionPaymentReferenceInformationScheduleProps = {
  customerCode: string;
};

const CollectionPaymentReferenceInformationSchedule: React.FC<CollectionPaymentReferenceInformationScheduleProps> = ({
  customerCode
}) => {
  //? THÔNG TIN TIỀN ĐIỆN ĐƯỢC CÔNG TY ĐIỆN LỰC ĐƯA LÊN HỆ THỐNG THU HỘ
  const columns1: TableProps<ThirdPartyPaymentInforDetail>['columns'] = [
    {
      title: (
        <Typography.Text className='text-left text-[12px]/[20px] font-semibold uppercase tracking-normal text-[#868D96] opacity-100'>
          {customerLookupDetailedMessages.month}/{customerLookupDetailedMessages.year}-
          {customerLookupDetailedMessages.cycleNumber}
        </Typography.Text>
      ),
      dataIndex: customerLookupDetailedMessages.cycleNumber,
      key: customerLookupDetailedMessages.cycleNumber,
      render: (_, data) => (
        <Typography.Text className='text-left text-[14px]/[18px] tracking-normal text-[#141414] opacity-100'>
          {Number(data.period) - 1}/20{data.year}-{data.batch}
        </Typography.Text>
      )
    },
    {
      title: (
        <Typography.Text className='text-left text-[12px]/[20px] font-semibold uppercase tracking-normal text-[#868D96] opacity-100'>
          {customerLookupDetailedMessages.billCode}
        </Typography.Text>
      ),
      dataIndex: customerLookupDetailedMessages.billCode,
      key: customerLookupDetailedMessages.billCode,
      render: (_, data) => (
        <Typography.Text className='text-left text-[14px]/[18px] font-semibold tracking-normal text-[#141414] opacity-100'>
          {data.invoiceId}
        </Typography.Text>
      )
    },
    {
      title: (
        <Typography.Text className='text-left text-[12px]/[20px] font-semibold uppercase tracking-normal text-[#868D96] opacity-100'>
          {customerLookupDetailedMessages.billType}
        </Typography.Text>
      ),
      dataIndex: customerLookupDetailedMessages.billType,
      key: customerLookupDetailedMessages.billType,
      render: (_, data) => (
        <Typography.Text className='text-left text-[14px]/[18px] tracking-normal text-[#141414] opacity-100'>
          {data.invoiceName}
        </Typography.Text>
      )
    },
    {
      title: (
        <Typography.Text className='text-left text-[12px]/[20px] font-semibold uppercase tracking-normal text-[#868D96] opacity-100'>
          {customerLookupDetailedMessages.amount}
        </Typography.Text>
      ),
      dataIndex: customerLookupDetailedMessages.amount,
      key: customerLookupDetailedMessages.amount,
      render: (_, data) => (
        <Typography.Text className='text-left text-[14px]/[18px] font-semibold tracking-normal text-[#141414] opacity-100'>
          {data.amount.toLocaleString('vi-VN')}
        </Typography.Text>
      )
    }
  ];

  //? Thông tin thanh toán khách hàng qua kênh thu hộ
  const columns2: TableProps<ThirdPartyPaymentHistoryDetail>['columns'] = [
    {
      title: (
        <Typography.Text className='text-left text-[12px]/[20px] font-semibold uppercase tracking-normal text-[#868D96] opacity-100'>
          {customerLookupDetailedMessages.month}/{customerLookupDetailedMessages.year}-
          {customerLookupDetailedMessages.cycleNumber}
        </Typography.Text>
      ),
      dataIndex: customerLookupDetailedMessages.cycleNumber,
      key: customerLookupDetailedMessages.cycleNumber,
      render: (_, data) => {
        return (
          <Typography.Text className='text-left text-[14px]/[18px] tracking-normal text-[#141414] opacity-100'>
            {data.invoiceMonth}/20{data.invoiceYear}-{data.invoicePeriod}
          </Typography.Text>
        );
      }
    },
    {
      title: (
        <Typography.Text className='text-left text-[12px]/[20px] font-semibold uppercase tracking-normal text-[#868D96] opacity-100'>
          {customerLookupDetailedMessages.billType}
        </Typography.Text>
      ),
      dataIndex: customerLookupDetailedMessages.billType,
      key: customerLookupDetailedMessages.billType,
      render: (_, data) => (
        <Typography.Text className='text-left text-[14px]/[18px] tracking-normal text-[#141414] opacity-100'>
          {data.invoiceTypeName}
        </Typography.Text>
      )
    },
    {
      title: (
        <Typography.Text className='text-left text-[12px]/[20px] font-semibold uppercase tracking-normal text-[#868D96] opacity-100'>
          {customerLookupDetailedMessages.collectionPoint}
        </Typography.Text>
      ),
      dataIndex: customerLookupDetailedMessages.collectionPoint,
      key: customerLookupDetailedMessages.collectionPoint,
      render: (_, data) => (
        <Typography.Text className='text-left text-[14px]/[18px] font-semibold tracking-normal text-[#141414] opacity-100'>
          {data.paymentPoint}
        </Typography.Text>
      )
    },
    {
      title: (
        <Typography.Text className='text-left text-[12px]/[20px] font-semibold uppercase tracking-normal text-[#868D96] opacity-100'>
          {customerLookupDetailedMessages.amount}
        </Typography.Text>
      ),
      dataIndex: customerLookupDetailedMessages.amount,
      key: customerLookupDetailedMessages.amount,
      render: (_, data) => (
        <Typography.Text className='text-left text-[14px]/[18px] font-semibold tracking-normal text-[#141414] opacity-100'>
          {data.totalAmount.toLocaleString('vn-VN')}
        </Typography.Text>
      )
    },
    {
      title: (
        <Typography.Text className='text-left text-[12px]/[20px] font-semibold uppercase tracking-normal text-[#868D96] opacity-100'>
          {customerLookupDetailedMessages.paymentCollectionDate}
        </Typography.Text>
      ),
      dataIndex: customerLookupDetailedMessages.paymentCollectionDate,
      key: customerLookupDetailedMessages.paymentCollectionDate,
      render: (_, data) => (
        <Typography.Text className='text-left text-[14px]/[18px] tracking-normal text-[#141414] opacity-100'>
          {dayjs(data.paymentDateTime).format('DD/MM/YYYY HH:mm:ss')}
        </Typography.Text>
      )
    }
  ];

  const { thirdPartyInfo, isLoading: thirdPartyInfoLoading } = GetCustomerThirdParty(String(customerCode));
  const { thirdPartyHistory, isLoading: thirdPartyHistoryLoading } = GetCustomerThirdPartyHistory(String(customerCode));

  const [information, setInformation] = useState<ThirdPartyPaymentInforDetail[]>([]);
  const [history, setHistory] = useState<ThirdPartyPaymentHistoryDetail[]>([]);
  // Khi đổi mã khách hàng --> xóa dữ liệu cũ trước khi chờ API
  useEffect(() => {
    setInformation([]);
    setHistory([]);
  }, [customerCode]);

  useEffect(() => {
    if (!customerCode) return;

    const infoMapped = thirdPartyInfo.map((item) => ({
      ...item,
      amount: Number(item.amount)
    }));

    const historyMapped = thirdPartyHistory
      .map((item) => ({
        key: `${item.customerCode}-${item.invoiceSeries ?? ''}-${item.paymentDateTime ?? ''}`,
        ...item,
        totalAmount: Number(item.totalAmount)
      }))
      .sort((a, b) => dayjs(b.paymentDateTime).valueOf() - dayjs(a.paymentDateTime).valueOf());

    // console.log(historyMapped);

    setInformation(infoMapped);
    setHistory(historyMapped);
  }, [thirdPartyInfo, thirdPartyHistory, customerCode]);

  const { customer: customerDetail } = useCustomerDetailByCustomerCode(customerCode || '');

  return (
    <div className='mt-3 w-full bg-[#FFFFFF]'>
      {customerCode && (
        <section className='mb-6 flex flex-col justify-between gap-2'>
          <Typography.Text>
            Tên khách hàng:{' '}
            <Typography.Text className={'font-bold'}>
              {customerDetail?.customerName ? customerDetail?.customerName : ''}
            </Typography.Text>
          </Typography.Text>
          <Typography.Text>
            Địa chỉ:{' '}
            <Typography.Text className={'font-bold'}>
              {customerDetail?.customerAddress ? customerDetail?.customerAddress : ''}
            </Typography.Text>
          </Typography.Text>
        </section>
      )}

      <Divider className='mt-4' />
      <Typography.Text className='text-left text-[12px]/[16px] font-semibold uppercase tracking-normal text-[#6C737E] opacity-100'>
        {customerLookupDetailedMessages.electricityBillingInformationOnCollectionSystem}
      </Typography.Text>
      <Table
        columns={columns1}
        dataSource={customerCode ? information : []}
        loading={thirdPartyInfoLoading}
        className='mt-2'
        rowKey={(row) => `${row.customerCode}-${row.invoiceId}`}
      />
      <Typography.Text className='text-left text-[12px]/[16px] font-semibold uppercase tracking-normal text-[#6C737E] opacity-100'>
        {customerLookupDetailedMessages.customerPaymentInformationOnCollectionChanel}
      </Typography.Text>
      <Table
        columns={columns2}
        dataSource={customerCode ? history : []}
        loading={thirdPartyHistoryLoading}
        className='mt-2'
      />
    </div>
  );
};

export default CollectionPaymentReferenceInformationSchedule;
